import { useCallback, useEffect } from "react";
import useGeoLocation from "../../../../hooks/useGeoLocation";

const useLocationSetup = () => {
  const { latitude, longitude, updateLocation } = useGeoLocation();

  // 내 위치 업데이트
  const updateMyLocation = useCallback(async () => {
    await updateLocation();
  }, [updateLocation]);

  // iOS 위치 권한 체크
  const checkiOSLocationPermission = useCallback(() => {
    if (latitude === 37.493743896484375 && longitude === 127.0637597) {
      // TODO: iOS 위치 권한 다이얼로그 구현 시 주석 해제
      // openDialog({
      //   title: "정확한 위치(ios)",
      //   type: "web",
      //   text: "더욱 정확한 위치 정보를 얻기 위해<br>아래와 같이 설정하세요.<br><br>설정 -> 러너러너 -> 위치 -> 정확한 위치 허용",
      //   style: {
      //     display: "flex",
      //     justifyContent: "center",
      //     alignItems: "center",
      //     height: "100%",
      //   },
      // });
    }
  }, [latitude, longitude]);

  // 초기 위치 설정
  useEffect(() => {
    updateMyLocation();
  }, [updateMyLocation]);

  // iOS 위치 권한 체크
  useEffect(() => {
    checkiOSLocationPermission();
  }, [checkiOSLocationPermission]);

  return {
    latitude,
    longitude,
    updateMyLocation,
    checkiOSLocationPermission,
  };
};

export default useLocationSetup;
